import { Text } from "@/components/podkit/typography/Text";
import { durationBetweenTimestamps, timeAgo } from "@/format/time";
import type { PlainWorkflowExecution } from "@/queries/automation-queries";
import { Timestamp } from "@bufbuild/protobuf";
import { WorkflowExecutionPhase } from "gitpod-next-api/gitpod/v1/workflow_pb";
import type { FC } from "react";

export const WorkflowExecutionStatusText: FC<{ execution: PlainWorkflowExecution }> = ({ execution }) => {
    const phase = execution.status?.phase;
    const startedAt = execution.metadata?.startedAt;
    const finishedAt = execution.metadata?.finishedAt;
    const duration = execution.metadata?.startedAt
        ? durationBetweenTimestamps(execution.metadata.startedAt, execution.metadata.finishedAt || Timestamp.now())
        : undefined;

    const getStatusText = () => {
        switch (phase) {
            case WorkflowExecutionPhase.COMPLETED:
                if (duration && finishedAt) {
                    return `Completed ${timeAgo(new Timestamp(finishedAt).toDate())} • ${duration}`;
                }
                return "Completed";
            case WorkflowExecutionPhase.RUNNING:
                if (startedAt) {
                    return `Started ${timeAgo(new Timestamp(startedAt).toDate())} • ${duration}`;
                }
                return "Starting";
            case WorkflowExecutionPhase.PENDING:
                return "Pending";
            case WorkflowExecutionPhase.STOPPED:
                if (duration && finishedAt) {
                    return `Stopped ${timeAgo(new Timestamp(finishedAt).toDate())} • ${duration}`;
                }
                return "Stopped";
            case WorkflowExecutionPhase.STOPPING:
                return "Stopping";
            case WorkflowExecutionPhase.DELETED:
                return "Deleted";
            case WorkflowExecutionPhase.DELETING:
                return "Deleting";
            default:
                return "";
        }
    };

    return <Text className="text-sm text-content-muted">{getStatusText()}</Text>;
};
